import * as t from '../../actionTypes';

import filterCoursesByType from '../../utils/filterCoursesByType.js';

// const defaultStatusOptions = { submitting: false, success: false, error: false };
const requestStatusOptions = { loading: true, success: false, error: false };
const successStatusOptions = { loading: false, success: true, error: false };
const failureStatusOptions = { loading: false, success: false, error: true };

const initialState = {
  courses: {},
  readers: {},
  courseIds: [],
  readerIds: []
};

function hubCourses(state = initialState, { type, payload }) {
  switch (type) {
    case t.HUB_GET_COURSES:
      return {
        ...initialState,
        ...requestStatusOptions
      };
    case t.HUB_SET_COURSES:
      return {
        ...state,
        courses: payload
      };
    case t.HUB_GET_COURSES_SUCCESS: {
      const { standardCourses, readerBundles } = filterCoursesByType(payload.courses);
      return {
        ...state,
        courses: standardCourses,
        courseIds: Object.keys(standardCourses),
        readers: readerBundles,
        readerIds: Object.keys(readerBundles),
        ...successStatusOptions
      };
    }
    case t.HUB_GET_COURSES_FAILURE:
      return { ...state, ...failureStatusOptions };
    default:
      return state;
  }
}

export default hubCourses;
